import React from 'react'
import LandingPage from '../../../Components/client/Home'


function Home() {
  return (
    <div>
      <LandingPage/>
    </div>
  )
}

export default Home
